import React from 'react';
import { get } from 'lodash';
import AutosuggestDropdown from './AutosuggestDropdown';
import { FormFieldsData, useFormContext } from '../FormContext';
import { LoadingParams } from 'framework/list';

export const PAGE_SIZE = 30;

export interface SearchInputProps {
  source?: string;
  initialLabel?: Nullable<string>;
  labelHint?: string;
  nameSource?: string;
  searchString?: any;
  defaultFilter?: Object;
  noResultMessage?: string;
  mapResults?: (data: any) => any;
  searchRequest: (params: LoadingParams) => Object;
  props?: any;
  onChangeCallback?: (values: FormFieldsData) => void;
  customGetInitialValue?: () => Promise<string>;
  onInputChangeCallback?: (resultValue: string) => void;
  selectSuggestionMethod?: (searchValueId: StringOrNumber) => void;
  placeholder?: string;
  minSearchLength?: number;
  isInfinityLoading?: boolean;
}

const SearchInput = ({
  defaultFilter = {},
  searchRequest,
  searchString = 'searchString',
  minSearchLength = 0,
  isInfinityLoading = false,
  initialLabel,
  nameSource,
  ...props
}: SearchInputProps) => {
  const { data = {} } = useFormContext();
  const initialValue = initialLabel || (nameSource && get(data, nameSource)) || data[nameSource || 0];

  const loadSuggestions = (searchValue: string, loadCurrentPage = 0) => {
    if ((searchValue || '').trim().length < minSearchLength) {
      return Promise.resolve({ result: [], totalPages: 0 });
    }

    const searchFilter = {
      [searchString]: { ct: searchValue },
    };

    return searchRequest({
      filter: {
        ...searchFilter,
        ...defaultFilter,
      },
      pageSize: PAGE_SIZE,
      pageNumber: loadCurrentPage,
    });
  };

  return (
    // @ts-ignore
    <AutosuggestDropdown
      loadSuggestionsMethod={loadSuggestions}
      resultsPerPage={PAGE_SIZE}
      initialValue={initialValue}
      searchRequest={searchRequest}
      isInfinityLoading={isInfinityLoading}
      {...props}
    />
  );
};

export default SearchInput;
